import {remote} from '../constants/environment';
import {defaultFetchDelay} from '../constants/environment/defaults';
import {INewClientRequest} from '../interfaces/dtos';
import {IStandardServiceResponse} from '../interfaces/services/standard-service.interface';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {defaultHeaders} from './headers';

export const postNewClientRequest = async (
  request: INewClientRequest,
  token: string,
  hasTimeOut = true,
): Promise<IStandardServiceResponse> => {
  const controller = new AbortController();
  const signal = hasTimeOut ? controller.signal : null;
  const timeoutId = setTimeout(() => {
    controller.abort();
  }, defaultFetchDelay);

  const handleResponse = async (response: Response) => {
    clearTimeout(timeoutId);
    if (response.status === 200) {
      const data = await response.json();
      //     {"success":false,"payload":{},"error":{"code":"422","message":"Cliente duplicado"}}
      if (data.success && data.payload) {
        return {
          success: true,
          payload: {},
        };
      }
    }

    return {
      success: false,
      payload: {},
    };
  };

  const remoteURI = remote.getClientsUri();
  const body = JSON.stringify({
    payload: request,
  });

  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'POST',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
        body,
        signal,
      });
    },
    handleResponse,
    remoteURI,
  )) as IStandardServiceResponse;
};
